export default __webpack_public_path__ + "static/media/submission-by-zipcode.da9387f4.svg";